import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { ISearchOption } from '@sky-it-elections/design-system/';

import HtmlWrapper from '../html-wrapper/html-wrapper';

import { ISearchInputWrapper } from './search-input';

const SearchInputWrapper = React.lazy(() => import('./search-input'));

export const SEARCH_INPUT_TAG = 'ld-search-input-widget';

export interface IDynamicSearchInput extends ISearchInputWrapper {
  children?: React.ReactNode;
}

const DynamicSearchInput: React.FC = (props) => {
  const { children, options, title, placeholder, url } = props as IDynamicSearchInput;
  const args: ISearchInputWrapper = {
    options: typeof options === 'string' ? JSON.parse(options) : options,
    title,
    placeholder,
    url,
  };

  return (
    <Suspense fallback={<HtmlWrapper html={children} />}>
      <SearchInputWrapper {...args} />
    </Suspense>
  );
};

DynamicSearchInput.propTypes = {
  options: PropTypes.arrayOf<ISearchOption>(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  placeholder: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
};

DynamicSearchInput.defaultProps = {
  // children: null,
  title: '',
  placeholder: undefined,
  url: undefined,
};

export default DynamicSearchInput;
